import { IMenuItem } from '../../models/menu.model';

/**
 * Menu configuration for Regulatory Desk.
 * Contains menu items for regulatory and authorization tasks.
 */
export const supervisionMenu: IMenuItem = {
  label: `Regulatory Desk`,
  path: `supervision-desk`,
  id: 'MID_REGULATORY_DESK',
  icon: 'fa fa-clipboard-check',
  children: [
    { path: `applications`, label: `Applications`, id: 'MID_REGULATORY_APPLICATIONS' },
    { path: `licenses`, label: `License Applications`, id: 'MID_REGULATORY_LICENSES' },
    { path: `supervisory-returns`, label: `Supervisory Returns`, id: 'MID_REGULATORY_SUPERVISORY_RETURNS' },
    { path: `infractions`, label: `Infractions`, id: 'MID_REGULATORY_INFRACTIONS' },
    { path: `approved-products`, label: `Approved Products`, id: 'MID_REGULATORY_APPROVED_PRODUCTS' },
    { path: `statutory-roles`, label: `Statutory Roles`, id: 'MID_REGULATORY_STATUTORY_ROLES' },
  ],
};
